module.exports = __webpack_public_path__ + "img/Frente-18-00 off.ec607491.png";